module.exports = __webpack_public_path__ + "static/9-702f28badeb708502651f6461d6b3d26.jpg";